const muiDateFiled = () => {

}

export const bdDateFormat = (newDate) => {
    const newTempDate = new Date(newDate);
    const tempDate =
        (newTempDate.getDate() < 10 ? `0${newTempDate.getDate()}/` : `${newTempDate.getDate()}/`) +
        (newTempDate.getMonth() < 10 ? `0${newTempDate.getMonth() + 1}/` : `${newTempDate.getMonth() + 1}/`) +
        newTempDate.getFullYear();
    return tempDate;
}

export const laravelToJsDateFormat = (serverDate) => {
    const newTempDate = new Date(serverDate);
    const newDate =
        (newTempDate.getMonth() < 10
            ? `0${newTempDate.getMonth() + 1}/`
            : `${newTempDate.getMonth() + 1}/`) +
        (newTempDate.getDate() < 10
            ? `0${newTempDate.getDate()}/`
            : `${newTempDate.getDate()}/`) +
        newTempDate.getFullYear();
    return newDate;
}

export default muiDateFiled; 